import { render, staticRenderFns } from "./serviceNeedInfo.vue?vue&type=template&id=1c5919b2&scoped=true"
import script from "./serviceNeedInfo.vue?vue&type=script&lang=js"
export * from "./serviceNeedInfo.vue?vue&type=script&lang=js"
import style0 from "./serviceNeedInfo.vue?vue&type=style&index=0&id=1c5919b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5919b2",
  null
  
)

export default component.exports